import { AxiosService } from '../../../services/axios.service'

const baseURL = 'cliente'

/**
 * @return {Promise<{succes: boolean, erros: string[]}>} The response
 * @param {object} clientData The client data
 */
const registerClient = clientData =>
	AxiosService.post(`${baseURL}/registrar`, clientData).then(({ data }) => data)

export { registerClient }
